<template>
    <div id="app">
        <hsHeader />
        <div class="layout">
            <transition name="fade" :duration="100">
                <router-view />
            </transition>
        </div>
        <hsFooter />
    </div>
</template>

<script>
import hsHeader from '@/components/public/heads.vue'
import hsFooter from '@/components/public/footers.vue'
export default {
    name: 'App',
    provide () {
        return {
            
        }
    },
    data () {
        return {
            data:'',
        }
    },
    watch: {
        $route () {
            if(window.getCookie('zh_choose')){
                setTimeout(() => {
                    window.zh_tran(window.getCookie('zh_choose')) 
                }, 1000);
                setTimeout(() => {
                    window.zh_tran(window.getCookie('zh_choose')) 
                }, 2000);
                setTimeout(() => {
                    window.zh_tran(window.getCookie('zh_choose')) 
                }, 3000);
                setTimeout(() => {
                    window.zh_tran(window.getCookie('zh_choose')) 
                }, 4000);
            }
        }
    },
    components: {
        hsHeader,
        hsFooter
    },
    methods:{
        
    },
}
</script>

<style>
#app {
    min-width: 1200px;
}
</style>
